import React from "react";
import PropTypes from "prop-types";
// Material Imports
import { hexToRgb, useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import UserAvatar from "../../user-avatar/UserAvatar";
import FadeUp from "../../animation/fade-up/FadeUp";
const useStyles = makeStyles(({
  palette,
  typography
}) => {
  var _palette$dialogues$ex, _palette$dialogues, _palette$dialogues$ex2, _palette$dialogues$ex3, _palette$dialogues2, _palette$dialogues2$e, _palette$dialogues$ex4, _palette$dialogues3, _palette$dialogues3$e, _palette$dialogues$ex5, _palette$dialogues4, _palette$dialogues4$e;
  const background = (_palette$dialogues$ex = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$ex2 = _palette$dialogues.expert) === null || _palette$dialogues$ex2 === void 0 ? void 0 : _palette$dialogues$ex2.background) !== null && _palette$dialogues$ex !== void 0 ? _palette$dialogues$ex : palette.primary.light;
  const text = (_palette$dialogues$ex3 = (_palette$dialogues2 = palette.dialogues) === null || _palette$dialogues2 === void 0 ? void 0 : (_palette$dialogues2$e = _palette$dialogues2.expert) === null || _palette$dialogues2$e === void 0 ? void 0 : _palette$dialogues2$e.text) !== null && _palette$dialogues$ex3 !== void 0 ? _palette$dialogues$ex3 : palette.primary.dark;
  const borderRadius = (_palette$dialogues$ex4 = (_palette$dialogues3 = palette.dialogues) === null || _palette$dialogues3 === void 0 ? void 0 : (_palette$dialogues3$e = _palette$dialogues3.expert) === null || _palette$dialogues3$e === void 0 ? void 0 : _palette$dialogues3$e.borderRadius) !== null && _palette$dialogues$ex4 !== void 0 ? _palette$dialogues$ex4 : 12;
  const expertTextFont = (_palette$dialogues$ex5 = (_palette$dialogues4 = palette.dialogues) === null || _palette$dialogues4 === void 0 ? void 0 : (_palette$dialogues4$e = _palette$dialogues4.expert) === null || _palette$dialogues4$e === void 0 ? void 0 : _palette$dialogues4$e.fontFamily) !== null && _palette$dialogues$ex5 !== void 0 ? _palette$dialogues$ex5 : typography.fontFamily;
  return {
    //expert classes
    expertText: {
      color: text,
      fontFamily: expertTextFont
    },
    expertBackground: {
      backgroundColor: background
    },
    expertTyping: {
      backgroundColor: text
    },
    blurText: {
      color: "transparent",
      textShadow: `0 0 10px ${hexToRgb(palette.secondary.dark)}`,
      userSelect: "none"
    },
    listItem: {
      display: "flex",
      marginLeft: 5,
      position: "relative",
      borderRadius,
      padding: 16,
      flexDirection: "column"
    },
    responseTime: {
      display: "flex",
      flex: "1",
      justifyContent: "flex-start",
      paddingTop: 5,
      paddingLeft: 5
    },
    //classes for this comp
    avatar: {
      boxShadow: "0px 0px 5px 2px rgba(97, 97, 97, 1)"
    },
    avatarContainer: {
      paddingLeft: 5
    },
    responseContainer: {
      paddingTop: 10,
      paddingBottom: 10
    },
    responseListContainer: {
      display: "flex",
      flex: "1",
      flexDirection: "row",
      maxWidth: "90%"
    }
  };
});
const ExpertDialogueWrapper = ({
  shouldAnimate,
  children,
  expertInfo,
  author,
  dialogueContainerOverrides = ""
}) => {
  var _theme$palette$userAv, _theme$palette$userAv2, _theme$palette$userAv3, _theme$palette$userAv4;
  const classes = useStyles();
  const theme = useTheme();
  const thumbnail = expertInfo ? expertInfo.thumbnail : null;
  const hideExpertAvatar = !expertInfo ? true : false;
  return /*#__PURE__*/React.createElement(FadeUp, {
    shouldAnimate: shouldAnimate
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.responseContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classes.responseListContainer} ${dialogueContainerOverrides}`
  }, !hideExpertAvatar && /*#__PURE__*/React.createElement("div", {
    className: classes.avatarContainer
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    author: author,
    thumbnail: thumbnail,
    customerAvatarStyle: {
      backgroundColor: (_theme$palette$userAv = (_theme$palette$userAv2 = theme.palette.userAvatar) === null || _theme$palette$userAv2 === void 0 ? void 0 : _theme$palette$userAv2.backgroundColor) !== null && _theme$palette$userAv !== void 0 ? _theme$palette$userAv : "#bdbdbd",
      color: (_theme$palette$userAv3 = (_theme$palette$userAv4 = theme.palette.userAvatar) === null || _theme$palette$userAv4 === void 0 ? void 0 : _theme$palette$userAv4.color) !== null && _theme$palette$userAv3 !== void 0 ? _theme$palette$userAv3 : "#fff"
    }
  })), children(classes))));
};
export default ExpertDialogueWrapper;
ExpertDialogueWrapper.propTypes = {
  shouldAnimate: PropTypes.bool.isRequired,
  children: PropTypes.func.isRequired,
  expertInfo: PropTypes.object,
  author: PropTypes.string,
  hideExpertAvatar: PropTypes.bool,
  dialogueContainerOverrides: PropTypes.string
};
ExpertDialogueWrapper.defaultProps = {
  hideExpertAvatar: false
};